// Indiana Vinoteca - Datos Reales
// Fuente: Google Maps + Instagram

export const businessData = {
  name: "Indiana",
  tagline: "Almacén de Vinos",
  logo: "https://customer-assets.emergentagent.com/job_e7e0d56d-2ef5-41fe-acb6-8cf11ab4413d/artifacts/rg3qfb6v_indiana-logo.jpg",
  rating: 4.6,
  totalReviews: 197,
  address: "Av. Facundo Zuviría 5131, S3002ESA Santa Fe de la Vera Cruz, Santa Fe",
  phone: "+54 342 559-0194",
  whatsappLink: "https://wa.me/543425590194?text=Hola%20Indiana,%20quería%20hacer%20una%20consulta",
  instagram: "https://www.instagram.com/indiana.vinoteca",
  googleMapsLink: "https://www.google.com/maps/search/?api=1&query=Av.+Facundo+Zuvir%C3%ADa+5131,+Santa+Fe,+Argentina",
  googleMapsReviewsLink: "https://www.google.com/maps/search/?api=1&query=Indiana+Av.+Facundo+Zuvir%C3%ADa+5131+Santa+Fe",
  
  schedule: [
    { day: "Lunes", hours: "9:00–13:00 y 17:00–20:30" },
    { day: "Martes", hours: "9:00–13:00 y 17:00–20:30" },
    { day: "Miércoles", hours: "9:00–13:00 y 17:00–20:30" },
    { day: "Jueves", hours: "9:00–13:00 y 17:00–20:30" },
    { day: "Viernes", hours: "9:00–13:00 y 17:00–20:30" },
    { day: "Sábado", hours: "9:00–13:00 y 17:00–20:30" },
    { day: "Domingo", hours: "9:00–13:00" }
  ],
  
  products: [
    { name: "Vinos", icon: "Wine" },
    { name: "Whiskys", icon: "GlassWater" },
    { name: "Gins", icon: "Martini" },
    { name: "Vodkas", icon: "Sparkles" },
    { name: "Tequilas", icon: "Sun" },
    { name: "Licores", icon: "Cherry" },
    { name: "Cervezas", icon: "Beer" },
    { name: "Tabacos", icon: "Cigarette" },
    { name: "Regalería", icon: "Gift" }
  ],
  
  paymentMethods: [
    "Efectivo",
    "Crédito",
    "Débito",
    "Transferencia"
  ],
  
  reviews: [
    {
      author: "Cliente verificado",
      text: "Excelente variedad de vinos y muy buena atención. El local tiene un ambiente agradable y el personal conoce muy bien los productos.",
      rating: 5
    },
    {
      author: "Cliente verificado",
      text: "Gran selección de bebidas premium. Siempre encuentro lo que busco y los precios son competitivos para la calidad que ofrecen.",
      rating: 5
    },
    {
      author: "Cliente verificado",
      text: "Muy recomendable para quienes buscan productos de calidad. La atención es personalizada y te asesoran según tus gustos.",
      rating: 5
    }
  ]
};
